import { useStore } from "vuex";
import { computed } from "vue";
import { User } from "../types/user";

export function useCurrentUser() {
  const store = useStore();
  return computed<User>(() => store.getters.currentUser);
}
